import React from "react";
import {
  Dapplets,
  Dracula,
  Etherna,
  Fairphoto,
  Galileo,
  GetLogin,
  Grassroot,
  Memez,
  Personium,
  Scaleout,
  Waggle,
  Zoomerok,
  DappletsLight,
  DraculaLight,
  EthernaLight,
  FairphotoLight,
  GalileoLight,
  GetLoginLight,
  GrassrootLight,
  MemezLight,
  PersoniumLight,
  ScaleoutLight,
  WaggleLight,
  ZoomerokLight,
} from "../icons/icons";

export const ecosystemLinks = [
  {
    label: "Dracula",
    icon: <Dracula />,
    href: "https://app.dracula.fairdatasociety.org/",
  },
  {
    label: "Galileo",
    icon: <Galileo />,
    href: "https://fairmaps.fairdatasociety.org/map",
  },
  {
    label: "Etherna",
    icon: <Etherna />,
    href: "http://etherna.io/",
  },
  {
    label: "Zoomerok",
    icon: <Zoomerok />,
    href: "https://github.com/IgorShadurin/zoomerok-new",
  },
  {
    label: "Dapplets",
    icon: <Dapplets />,
    href: "https://dapplets.org/",
  },
  {
    label: "Personium",
    icon: <Personium />,
    href: "https://personium.io/",
  },
  {
    label: "Scaleout Systems",
    icon: <Scaleout />,
    href: "https://www.scaleoutsystems.com/",
  },
  {
    label: "Grassroot Economics",
    icon: <Grassroot />,
    href: "http://grassrooteconomic.org/",
  },
  {
    label: "Waggle",
    icon: <Waggle />,
    href: "https://github.com/WaggleMail/docs",
  },
  {
    label: "GetLogin",
    icon: <GetLogin />,
    href: "https://getlogin.swarm-gateways.net/",
  },
  {
    label: "Fairphotos",
    icon: <Fairphoto />,
    href: "https://app.photo.fairdatasociety.org/",
  },
  {
    label: "Memez",
    icon: <Memez />,
    href: "https://github.com/igar1991/memez-swarm",
  },
];

export const ecosystemLinksLight = [
  {
    label: "Dracula",
    icon: <DraculaLight />,
    href: "https://app.dracula.fairdatasociety.org/",
  },
  {
    label: "Galileo",
    icon: <GalileoLight />,
    href: "https://fairmaps.fairdatasociety.org/map",
  },
  {
    label: "Etherna",
    icon: <EthernaLight />,
    href: "http://etherna.io/",
  },
  {
    label: "Zoomerok",
    icon: <ZoomerokLight />,
    href: "https://github.com/IgorShadurin/zoomerok-new",
  },
  {
    label: "Dapplets",
    icon: <DappletsLight />,
    href: "https://dapplets.org/",
  },
  {
    label: "Personium",
    icon: <PersoniumLight />,
    href: "https://personium.io/",
  },
  {
    label: "Scaleout Systems",
    icon: <ScaleoutLight />,
    href: "https://www.scaleoutsystems.com/",
  },
  {
    label: "Grassroot Economics",
    icon: <GrassrootLight />,
    href: "https://www.grassrootseconomics.org/",
  },
  {
    label: "Waggle",
    icon: <WaggleLight />,
    href: "https://github.com/WaggleMail/docs",
  },
  {
    label: "GetLogin",
    icon: <GetLoginLight />,
    href: "https://github.com/GetLoginEth/login",
  },
  {
    label: "Fairphotos",
    icon: <FairphotoLight />,
    href: "https://app.photo.fairdatasociety.org/",
  },
  {
    label: "Memez",
    icon: <MemezLight />,
    href: "https://github.com/igar1991/memez-swarm",
  },
];
